import { createFileRoute } from '@tanstack/react-router'
import Sertifikalar from '@/modules/sertifikalar'

export const Route = createFileRoute('/_authenticated/sertifikalar/')({
  component: Sertifikalar,
})
